module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/230.95d969bd.png";